<template>
    <v-tabs-items v-model="tab" touchless class="h-100">
        <slot v-bind="{ tab, prev, next }" />
    </v-tabs-items>
</template>

<script>
import { TABS } from "./lib";

export default {
    props: {
        value: { type: String, default: TABS.CREATE.value },
    },
    data: () => ({
        tab: TABS.CREATE.value,
    }),
    mounted() {
        this.sync();
    },
    watch: {
        value() {
            this.sync();
        },
    },
    methods: {
        sync() {
            this.tab = this.value;
        },
        emit() {
            this.$emit("input", this.tab);
        },
        prev() {
            this.tab = TABS.CREATE.value;
            this.emit();
        },
        next(tab) {
            this.tab = tab;
            this.emit();
        },
    },
};
</script>

<style></style>
